import ContentBlock from "../../components/UI/ContentBlock"
import ContentCard from "../../components/UI/ContentCard"
import styled from "styled-components"
import {useEffect, useMemo, useState} from "react"
import {Badge, Button, Checkbox, Divider, InputNumber, Modal} from "antd"
import Slider from "rc-slider"
import AsyncStorage from "@react-native-async-storage/async-storage"
import {prettyDigit} from "../../library/methods/prettyDigit"
import {round} from "lodash"
import {useNavigate} from "react-router-dom"
import Icon from "../../components/Icon/Icon"
import {faChartLineUp, faCircleNodes, faUsers} from "@fortawesome/pro-light-svg-icons"
import ContactForm from "../../components/ContactForm"

const inputNumberProps = {
	style: {width: 110, fontSize: 16, fontWeight: '500', padding: 0, margin: 0},
	formatter: (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

const options = {
	points: [
		{type: 'routing', title: 'Маршрутизация', description: 'Планирование маршрутов', icon: faCircleNodes},
		{
			type: 'motivation',
			title: 'Мотивация водителей',
			description: 'Зарплата, баллы, категории',
			icon: faChartLineUp
		},
		//{type: 'fines', title: 'Штрафы', description: 'Все виды штрафов', icon: faReceipt},
		//{type: 'parking', title: 'Парковки', description: 'Оплата городских парковок', icon: faSquareParking},
		//{type: 'paid_roads', title: 'Платные дороги', description: 'МСД, АВТОДОР', icon: faRoad},
		{type: 'observers', title: 'Кабинет клиента', description: 'Доступ к мониторингу', icon: faUsers}
	],
	transport: [
		{type: 'sensors', title: 'Датчики'}
	]
}

const PriceScreen = () => {
	const navigate = useNavigate()

	const [open, setOpen] = useState(null)
	const [settings, setSettings] = useState(null)

	useEffect(() => {
		document.title = 'АТС24 — Тарифы на подключение'
	}, [])

	useEffect(() => {
		load()
	}, [])

	const result = useMemo(() => {
		const data = {
			monitoring: {
				title: "Мониторинг доставки",
				price: 0,
				from: false,
				description: 'Статусы и время посещения точек, мобильное приложение водителя'
			}
		}

		if (!settings) return data

		for (let i = 1; i < settings.count.points + 1; i++) {
			if (i >= 1 && i <= 7500) data.monitoring.price += 2.5
			if (i >= 7501 && i <= 15000) data.monitoring.price += 2.2
			if (i >= 15001 && i <= 30000) data.monitoring.price += 1.9
			if (i >= 30001 && i <= 60000) data.monitoring.price += 1.6
			if (i >= 60001 && i <= 120000) data.monitoring.price += 1.3
			if (i >= 120001 && i <= 200000) data.monitoring.price += 1
			if (i >= 200001 && i <= 300000) data.monitoring.price += 0.8
			if (i >= 300001 && i <= 500000) data.monitoring.price += 0.6
			if (i >= 500001) data.monitoring.price += 0.5
		}

		if (!settings.count.points) {
			data.monitoring.price = 0
		} else if (data.monitoring.price < 9990) {
			data.monitoring.price = 9990
		}

		if (settings.options.routing && settings.count.points) {
			data.routing = {
				title: "Маршрутизация",
				price: 0,
				from: false,
				description: 'Автоматический и ручной режимы'
			}
			for (let i = 1; i < settings.count.points + 1; i++) {
				if (i >= 1 && i <= 7500) data.routing.price += 1.25
				if (i >= 7501 && i <= 15000) data.routing.price += 1.1
				if (i >= 15001 && i <= 30000) data.routing.price += 0.95
				if (i >= 30001 && i <= 60000) data.routing.price += 0.8
				if (i >= 60001 && i <= 120000) data.routing.price += 0.65
				if (i >= 120001 && i <= 200000) data.routing.price += 0.5
				if (i >= 200001 && i <= 300000) data.routing.price += 0.4
				if (i >= 300001 && i <= 500000) data.routing.price += 0.3
				if (i >= 500001) data.routing.price += 0.25
			}
		}

		if (settings.options.motivation && settings.count.points) {
			data.motivation = {
				title: "Мотивация водителей",
				price: 0,
				from: true,
				description: 'Оценка качества работы водителей'
			}
			for (let i = 1; i < settings.count.points + 1; i++) {
				if (i >= 1 && i <= 7500) data.motivation.price += 0.99
				if (i >= 7501 && i <= 13500) data.motivation.price += 0.79
				if (i >= 13501 && i <= 27000) data.motivation.price += 0.65
				if (i >= 27001 && i <= 45000) data.motivation.price += 0.55
				if (i >= 45001 && i <= 90000) data.motivation.price += 0.47
				if (i >= 90001 && i <= 135000) data.motivation.price += 0.39
				if (i >= 135001 && i <= 180000) data.motivation.price += 0.28
				if (i >= 180001) data.motivation.price += 0.2
			}
		}

		if (settings.options.parking && settings.count.points) {
			data.parking = {
				title: "Платная парковка",
				price: 0,
				from: true,
				description: 'Оплата в приложении, единый счёт, контроль'
			}
			for (let i = 1; i < settings.count.points + 1; i++) {
				if (i >= 1 && i <= 7500) data.parking.price += 0.99
				if (i >= 7501 && i <= 13500) data.parking.price += 0.79
				if (i >= 13501 && i <= 27000) data.parking.price += 0.65
				if (i >= 27001 && i <= 45000) data.parking.price += 0.55
				if (i >= 45001 && i <= 90000) data.parking.price += 0.47
				if (i >= 90001 && i <= 135000) data.parking.price += 0.39
				if (i >= 135001 && i <= 180000) data.parking.price += 0.28
				if (i >= 180001) data.parking.price += 0.2
			}
		}

		if (settings.options.observers && settings.count.points) {
			data.observers = {
				title: "Кабинет клиента",
				price: 990,
				from: true,
				description: 'Доступ к мониторингу вашим клиентам'
			}
		}

		if (settings.options.sensors && settings.count.transport) {
			data.sensors = {
				title: "Встроенные датчики",
				price: 0,
				from: false,
				description: 'Местоположение, температура, топливо'
			}
			for (let i = 1; i < settings.count.transport + 1; i++) {
				if (i >= 1 && i <= 5) data.sensors.price += 600
				if (i >= 6 && i <= 15) data.sensors.price += 450
				if (i >= 16 && i <= 30) data.sensors.price += 360
				if (i >= 31) data.sensors.price += 290
			}
		}

		return data
	}, [settings])

	const total = useMemo(() => {
		let data = 0
		Object.keys(result).map(key => {
			if (result[key].price > 0) data += result[key].price
		})

		return round(data)
	}, [result])

	const load = async () => {
		let params = await AsyncStorage.getItem('calculator')
		if (params) {
			params = JSON.parse(params)
		} else {
			params = {}
		}

		params = {
			...{
				count: {
					points: 3000,
					transport: 0
				},
				options: {
					routing: false,
					sensors: true
				}
			}, ...params
		}

		setSettings(params)
	}

	const onChangeCount = (type, value) => {
		let params = {...settings}
		params.count[type] = value
		setSettings(params)
		AsyncStorage.setItem('calculator', JSON.stringify(params))
	}

	const onChangeOptions = (type) => {
		let params = {...settings}
		params.options[type] = !params.options[type]
		setSettings(params)
		AsyncStorage.setItem('calculator', JSON.stringify(params))
	}

	const onBlurCount = () => {
		let params = {...settings}
		if (params.count.points === null) params.count.points = 100
		if (params.count.transport === null) params.count.transport = 0
		setSettings(params)
		AsyncStorage.setItem('calculator', JSON.stringify(params))
	}

	if (!settings) return null

	return (
		<>
			<ContentBlock top={3.33} bottom={0}>
				<ContentCard title="Тарифный калькулятор">
					<p>
						Оплачивайте только за объем адресов и транспортных средств, который необходим вашей компании.
					</p>
				</ContentCard>
			</ContentBlock>

			<ContentBlock top={3.33}>
				<CalculatorWrapper>
					<ParamsWrapper>
						<Param>
							<ParamHeader>
								<ParamTitle>Точек (адресов) в месяц</ParamTitle>
								<ParamInput>
									<InputNumber {...inputNumberProps} value={settings.count.points}
												 onChange={value => onChangeCount('points', value)}
												 min={100} max={300000} onBlur={onBlurCount}/>
								</ParamInput>
							</ParamHeader>
							<ParamSlider>
								<Slider max={300000} step={1000} min={100} value={settings.count.points}
										onChange={value => onChangeCount('points', value)}/>
							</ParamSlider>
							<ParamDescription>
								Укажите количество адресов в месяц, по которым осуществляются доставки и выберите опции:
							</ParamDescription>
						</Param>

						<AdditionalOptionsWrapper>
							<AdditionalOptionsCheckboxes>
								<Options>
									{options.points.map(option => (
										<Option key={option.type} onClick={() => onChangeOptions(option.type)}>
											<Checkbox key={option.type}
													  checked={settings.options[option.type]}
													  style={{pointerEvents: 'none'}}
											/>
											<OptionInfo>
												<OptionTitle>
													{option.title}
												</OptionTitle>
												<OptionDescription>
													{option.description}
												</OptionDescription>
											</OptionInfo>
											<Icon name={option.icon} size={22}
												  style={{
													  position: 'absolute',
													  opacity: .2,
													  right: 8,
													  top: 8
												  }}
											/>
										</Option>
									))}
								</Options>
							</AdditionalOptionsCheckboxes>
						</AdditionalOptionsWrapper>

						<Divider style={{marginBlock: 15}}/>

						<Param>
							<ParamHeader>
								<ParamTitle>Автомобили с датчиками</ParamTitle>
								<ParamInput>
									<InputNumber {...inputNumberProps} value={settings.count.transport} step={1}
												 onChange={value => onChangeCount('transport', value)}
												 min={0} max={600} onBlur={onBlurCount}/>
								</ParamInput>
							</ParamHeader>
							<ParamSlider>
								<Slider min={0} max={600} step={1} value={settings.count.transport}
										onChange={value => onChangeCount('transport', value)}/>
							</ParamSlider>
							<ParamDescription>
								Укажите количество ТС, которые вы планируете оснастить стационарными датчиками.
							</ParamDescription>
						</Param>

						<DetailsWrapper>
							<p>
								С подробной информацией о формировании тарифа вы можете ознакомиться по <a
								href="/price/details" target="_blank">ссылке</a>.
							</p>
						</DetailsWrapper>
					</ParamsWrapper>

					<Badge.Ribbon text="2 месяца бесплатно" color="red">
						<PriceWrapper>
							<TotalPriceWrapper>
								Итого в месяц
								<TotalPrice>
									{prettyDigit(total)} ₽
								</TotalPrice>
							</TotalPriceWrapper>
							<PriceItems>
								{Object.keys(result).map(key => (
									<PriceItem key={'c' + key}>
										<PriceInfo>
											<PriceTitle>{result[key].title}</PriceTitle>
											<PriceDescription>{result[key].description}</PriceDescription>
										</PriceInfo>
										<PriceSum>
											{(result[key].from ? 'от ' : '') + prettyDigit(result[key].price) + ' ₽'}
										</PriceSum>
									</PriceItem>
								))}
							</PriceItems>
							<ButtonWrapper>
								<Button onClick={() => setOpen(true)} color="green" variant="solid"
										size="large">
									Получить доступ
								</Button>
							</ButtonWrapper>
						</PriceWrapper>
					</Badge.Ribbon>
				</CalculatorWrapper>
			</ContentBlock>

			<Modal width={660} maskClosable={false} open={open} onCancel={() => setOpen(false)} footer={null}>
				<ModalContent>
					<ModalTitle>Новый заказ</ModalTitle>
					<div>Мы свяжемся с вами в самое ближайшее время.</div>
					<ContactForm onFinish={() => {
						setOpen(false)
					}}/>
				</ModalContent>
			</Modal>
		</>
	)
}

export default PriceScreen

const CalculatorWrapper = styled.div`
    display: flex;
    gap: 60px;
`
const ParamsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 550px;
    gap: 25px;
    padding: 24px 0 0 0;
`
const Param = styled.div`
    display: flex;
    flex-direction: column;
`
const ParamHeader = styled.div`
    display: flex;
    align-items: center;
`
const ParamTitle = styled.div`
    display: flex;
    flex: 1;
    font-size: 20px;
    font-weight: 450;
`
const ParamInput = styled.div`
    display: flex;
`
const ParamDescription = styled.div`
    display: flex;
    font-size: 16px;
    opacity: .8;
`
const ParamSlider = styled.div`
    display: flex;
    padding: 15px 0;
`
const AdditionalOptionsWrapper = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    align-self: flex-start;
    gap: 14px;
`
const AdditionalOptionsCheckboxes = styled.div`
    display: flex;
    flex: 1;
    gap: 24px;
`
const Options = styled.div`
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    gap: 6px 6px;
`
const Option = styled.div`
    display: flex;
    position: relative;
    align-items: flex-start;
    padding: 10px 15px;
    gap: 10px;
    border-radius: 10px;
    flex: 0 0 calc(50% - 3px);
    cursor: pointer;
    background-color: #f9fafb;
    transition: background-color .3s;
    overflow: hidden;

    :hover {
        background-color: #e9ecf2;
    }
`
const OptionInfo = styled.div`
    display: flex;
    flex-direction: column;
`
const OptionTitle = styled.div`
    font-weight: 600;
    font-size: 16px;
`
const OptionDescription = styled.div`
    margin-top: 5px;
    font-size: 14px;
    opacity: .7;
`
const PriceWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 520px;
    min-height: 600px;
    padding: 24px;
    gap: 40px;
    background-color: #EBF7EB;
    border-radius: 14px;
    overflow: hidden;
`
const TotalPriceWrapper = styled.div`
    display: flex;
    flex-direction: column;
`
const TotalPrice = styled.div`
    font-size: 32px;
    font-weight: bold;
`
const PriceItems = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 20px;
`
const PriceItem = styled.div`
    display: flex;
`
const PriceInfo = styled.div`
    display: flex;
    flex: .75;
    flex-direction: column;
    padding-right: 50px;
`
const PriceDescription = styled.div`
    font-size: 15px;
    opacity: .7;
`
const PriceSum = styled.div`
    display: flex;
    justify-content: flex-end;
    flex: .25;
`
const PriceTitle = styled.div`
    display: flex;
    flex: 1;
    font-weight: 550;
`
const ButtonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-self: flex-start;
    font-weight: 550;
`
const DetailsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: flex-end;
    font-size: 16px;
    font-style: italic;
    opacity: .7;
`
const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px;
    gap: 24px;
`
const ModalTitle = styled.div`
    font-size: 34px;
    line-height: 34px;
`